export const MASK_CHARS = ["a", "9", "*"];
